import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { envStorage } from "@/lib/storage/envIsolatedStorage";
import enUS from "./locales/en/translation.json";
import fr from "./locales/fr/translation.json";
import zhCN from "./locales/zh/translation.json";

const resources = {
  en: {
    translation: enUS,
  },
  zh: {
    translation: zhCN,
  },
  fr: {
    translation: fr,
  },
};

// Custom storage backend for i18next that uses envStorage
const customStorageBackend = {
  name: "customStorage",
  lookup() {
    return envStorage.getItem("i18nextLng") || undefined;
  },
  cacheUserLanguage(lng: string) {
    envStorage.setItem("i18nextLng", lng);
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "customStorage", "cookie", "navigator"],
      caches: ["customStorage", "cookie"],
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      // Custom storage detector
      customDetectors: [customStorageBackend],
    },
  });

export default i18n;
